import {createModel} from "@rematch/core";
import {RootModel} from "./index";
import request from "../util/request";

export const activity: any = createModel<RootModel>()({
  state: {
    list: [],
  }, // initial state
  reducers: {
    // handle state changes with pure functions
    /**
     * 设置值
     *
     * @param state
     * @param payload
     */
    setData(state, payload) {
      return {...state, ...payload}
    }
  },
  effects: (dispatch) => ({
    // handle state changes with impure functions.
    // use async/await for async actions
    /**
     * 获取活动列表
     */
    async list(payload, rootState) {
      let res = await request.get("/host-admin/v1/activity/list")
      if (res.code === 0) {
        dispatch.activity.setData({list: res.data})
      }
      return res
    },

  }),
})